import React, { useEffect, useState } from 'react';
import { CloseIcon, MaximizeIcon } from '../components/Icons.jsx';

/**
 * Everything the projected screen still puts on top of the slide, which is
 * as little as possible: a way into fullscreen, a way out of the deck, and a
 * dot when the connection drops.
 *
 * A browser will not go fullscreen without a gesture in the page itself —
 * opening a link in a new tab does not count — so "เริ่มฉาย" has to be a
 * button someone clicks. It sits in a corner rather than covering the slide,
 * because a projector that cannot enter fullscreen (mirrored HDMI, a locked-
 * down browser) must still be able to show the lesson.
 */
export default function ProjectorControls({ onExit }) {
  const [isFullscreen, setIsFullscreen] = useState(Boolean(document.fullscreenElement));

  useEffect(() => {
    const onFs = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', onFs);
    return () => document.removeEventListener('fullscreenchange', onFs);
  }, []);

  if (isFullscreen) return null;

  return (
    <div className="deck-projector-controls">
      <button
        className="btn btn-gold deck-projector-start"
        onClick={() => document.documentElement.requestFullscreen?.().catch(() => {})}
      >
        <MaximizeIcon size={16} /> เริ่มฉาย
      </button>
      <button className="deck-projector-exit" onClick={onExit} title="ออกจากจอฉาย">
        <CloseIcon size={16} />
      </button>
    </div>
  );
}

/** A quiet dot, bottom right. The class should not be reading error banners. */
export function ConnectionDot({ connected }) {
  if (connected) return null;
  return <span className="deck-offline-dot" title="การเชื่อมต่อหลุด" aria-hidden="true" />;
}
